import { render, staticRenderFns } from "./DormList.vue?vue&type=template&id=0884766e&scoped=true"
import script from "./DormList.vue?vue&type=script&lang=js"
export * from "./DormList.vue?vue&type=script&lang=js"
import style0 from "./DormList.vue?vue&type=style&index=0&id=0884766e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884766e",
  null
  
)

export default component.exports